export const marketLightTheme = {
  '--market-bgc-1': '#f8f8f8',
  '--market-bgc-2': '#eee',
  '--market-bgc-3': '#9fa7b3',
  '--market-bgc-4': '#fff',
  '--market-font-c-1': '#333',
  '--market-font-c-2': '#fff',
  '--market-font-c-3': '#333',
  '--market-font-c-4': '#65d5ff',
}
export const marketDarkTheme = {
  '--market-bgc-1': '#23262f',
  '--market-bgc-2': '#23262f',
  '--market-bgc-3': 'rgba(255, 255, 255, 0.75)',
  '--market-bgc-4': '#141417',
  '--market-font-c-1': '#fff',
  '--market-font-c-2': '#fff',
  '--market-font-c-3': '#9fa7b3',
  '--market-font-c-4': '#65d5ff',
}
